import React from 'react'
import { useTheme } from '@mui/material'
import { ICON_SIZE } from '../Icon/constants'
import { Frame } from './styles'
import type { FramedIconProps } from './types'

const FramedIcon: React.FC<FramedIconProps> = ({
  icon: Icon,
  color,
  size = ICON_SIZE.small,
  isFilled,
  backgroundColor,
}) => {
  const theme = useTheme()
  const iconColor = color ? color : theme.palette.secondary[200]

  return (
    <Frame backgroundColor={backgroundColor}>
      <Icon color={iconColor} size={size} isFilled={isFilled} />
    </Frame>
  )
}

export default FramedIcon
